export default __webpack_public_path__ + "static/media/recogida.90ba194c.svg";